import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white p-4">
                    <div className="max-w-md w-full text-center">
                        <h1 className="text-4xl font-bold mb-4 text-red-500">Something went wrong</h1>
                        <p className="mb-6 text-lg">We're sorry, but the application encountered an unexpected error.</p>
                        {this.state.error && (
                            <div className="text-left bg-gray-100 dark:bg-gray-800 p-4 rounded overflow-auto text-xs mb-6 max-h-64">
                                <p className="font-bold text-red-500 mb-2">Error Details:</p>
                                {this.state.error.toString()}
                                <br />
                                {this.state.errorInfo && this.state.errorInfo.componentStack}
                            </div>
                        )}
                        <button
                            onClick={() => window.location.reload()}
                            className="bg-black dark:bg-white text-white dark:text-black px-6 py-3 rounded-full font-bold hover:opacity-80 transition-opacity"
                        >
                            Reload Page
                        </button>
                        <div className="mt-4">
                            <a href="/" className="text-sm underline hover:text-primary-light">Go to Home</a>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
